/* global inmoneyadd, bet, inbigwin, big_win, black_screen_opened, fadeout_black_screen */

import {
    server_result,
    big_win,
    inbigwin,
    inmoneyadd,
    picture_convert,
    set_inanim,
    states, set_inbigwin
} from "../framework/src/engine/madnes/madnes_variables";
import {
    ctrl_end_round,
    ctrl_set_bonus,
    ctrls_set_clock,
    get_memory_index,
    in_bonus,
    refresh_bonus_count
} from "./jokerboom_ctrl";
import {get_result_special_state, set_cover_lightness} from "./jokerboom_reels";
import {madnes_get_texture, madnes_set_visible} from "../framework/src/engine/madnes/madnes_object";
import {madnes_audio_play} from "../framework/src/engine/madnes/madnes_audio";
import {
    bet,
    madnes_add_win, madnes_get_atomic_bet,
    madnes_set_win,
    madnes_win_anim_skip,
    win
} from "../framework/src/engine/madnes/madnes";
import {
    anims_pulse_boom_spins, anims_pulse_wild_reel,
    anims_scalein_boom_spins, anims_scaleout_boom_spins,
    anims_winline_play,
    black_screen_opened,
    close_black_screen, fadein_bonus_bg,
    fadeout_black_screen,
    open_black_screen, play_boomspins_particles
} from "./jokerboom_anims";
import {STATES} from "../framework/src/states/states";
import {anims_winlines_bigwin_play} from "./jokerboom_win";

var bigwin_played = false;

// Zacatek kontroly vyher
var result_control_pos = 0;

export var win_pos = 1;
export function set_win_pos(val) {
    win_pos = val;
}

export var boom_spins_count = 0;
export function set_boom_spins_count(val) {
    boom_spins_count = val;
}


var spin_win = 0;

export function result_control()
{
    if(inmoneyadd || inbigwin)
    {
        setTimeout(result_control, 100); //waiting for animation end
        return;
    }

    /*for(var i = 0; i <= 2; i++) {
        var symbolName = ctrl_get_reel_symbol_name(server_result.result.reelMatrix[0], 0, i);

        if(symbolName === "symbol_Wild") {
            madnes_set_texture("reels_bufer_" + 0 + "_S" + (i), "symbol_Wild_sprite2_json");
        }
    }*/

    refresh_bonus_count(bet, get_result_special_state()['wildMemory']);

    set_wild_lock_index();

    spin_win = 0;
    set_inanim(1); //inanim = 1;

    win_pos = 1;

    bigwin_played = false;

    result_control_pos = 0;
    result_control_part();
}

export function result_control_next_part()
{
    result_control_pos++;
    result_control_part();
}

function result_add_win(win_set)
{
    if(typeof win_set['win'] !== "undefined")
    {
        madnes_add_win(win_set['win'] * 1); // win = win * 1 + win_set['win'] * 1;
        spin_win = spin_win * 1 + win_set['win'] * 1;

        return true;
    }

    return false;
}

export function result_add_big_win()
{
    madnes_set_win(server_result['result']['totalWin'] * 1);
    spin_win = server_result['result']['totalWin'] * 1;
}

// kontrola vyhry na aktualni pozici
async function result_control_part()
{
    var lineWins = server_result.result.lineWins;

    if(server_result.result.totalWin >= madnes_get_atomic_bet() * big_win && !bigwin_played)
    {
        result_control_big_win(lineWins, server_result.result.totalWin);
        set_inbigwin(true);
    }
    else if(bigwin_played || (!lineWins || (lineWins && !lineWins[result_control_pos])))
    {
        if(black_screen_opened) {

            fadeout_black_screen().then(function() {
                close_black_screen();
                //endRound();
            });
        }

        ctrl_end_round(bigwin_played);

    }
    else
    {
        states.setState(STATES.SKIP);
        // madnes_hide_stop();

        /*if(lw[result_control_pos].type == 'freeSpins') {
            madnes_win_anim_reset();
        }*/

        if(madnes_win_anim_skip()) {
            //if(
            //	server_result.result.lineWins[result_control_pos].type == "wild" ||
            //	server_result.result.lineWins[result_control_pos].type == "normal"
            //) {
            if(typeof lineWins[result_control_pos]["win"] !== "undefined" && server_result.result.lineWins[result_control_pos]["type"] !== "full")
            {
                await madnes_add_win(lineWins[result_control_pos]["win"] * 1);  // win = win * 1 + lineWins[result_control_pos]["win"] * 1;
                spin_win = spin_win * 1 + lineWins[result_control_pos]["win"] * 1;
            }

            if(server_result.result.lineWins[result_control_pos]["type"] === "full") {
                spin_win = win = server_result['result']['totalWin'];
            }

            result_control_next_part();
            //} else {
            //	result_control_part_proc(server_result.result.lineWins[result_control_pos]);
            //}
        } else {
            result_control_part_proc(lineWins[result_control_pos]);
        }
    }
}

function result_control_part_proc(win_set)
{
    //inwincount = true;

    if(is_winline(win_set)) {

        open_black_screen();

        // madnes_win_anim_add();

        if(win_set["type"] == "normal") {

            result_add_win(win_set);

            anims_winline_play(win_set, 200, false).then(function() {
                //setTimeout(function() {
                result_control_next_part();
                //}, 500);
            });
        }

        if(win_set["type"] == "wild") {

            result_add_win(win_set);

            anims_winline_play(win_set, 300, false).then(function() {
                //setTimeout(function() {
                result_control_next_part();
                //}, 500);
            });
        }

    } else if(win_set["type"] == "scatter") {

        // madnes_show_stop();
        // madnes_hide_skip();

        //inwincount = false;
        return new Promise(function() {

            //var len = winSet.position.length > 3 ? 4 : 3;
            madnes_audio_play("win_stars");

            //var symbols = get_symbols_from_winset(win_set);

            var p1 = result_ctrl_anim_boom_spins(win_set.position.length > 3 ? "20" : "10");
            var p2 = anims_winline_play(win_set, 300, true);

            set_cover_lightness(true);

            Promise.all([p1, p2]).then(function() {
                return new Promise(function(res) {

                    result_ctrl_enter_bonus();

                    set_cover_lightness(false);

                    //anims_pulse_wild_reel();

                    setTimeout(res, 500);
                });
            })/*.then(function() {
				//result_ctrl_enter_bonus();
			})*/;
        });
    }
}

/**
 *
 * @param {string} num
 * @return {Promise<any>}
 */
function result_ctrl_anim_boom_spins(num)
{
    return new Promise(function(res) {

        //preload_bigwin_particles();

        setTimeout(play_boomspins_particles, 200);

        anims_scalein_boom_spins(num).then(function() {

            return anims_pulse_boom_spins(2800);

        }).then(function() {

            //hide_preload_bigwin_particles();

            return anims_scaleout_boom_spins();

        }).then(res);
    });
}

function result_ctrl_enter_bonus() {

    var wildMemory = get_result_special_state()['wildMemory'];

    refresh_bonus_count(bet, wildMemory);

    if(in_bonus) {

        setTimeout(function() {
            result_control_next_part();
        }, 200);

    } else {

        madnes_set_visible("bonus_count", true);

        ctrls_set_clock().then(function() {
            ctrl_set_bonus(wildMemory, false);
            setTimeout(function() {
                result_control_next_part();
            }, 350);
        });

        fadein_bonus_bg();
        anims_pulse_wild_reel();
    }
}

function is_winline(win_set) {
    return win_set['line'] != null && typeof win_set['line'] != "undefined" && win_set['line'] >= 0;
}

function result_control_big_win(lineWins, totalWin) {
    bigwin_played = true;

    //var lineWins = server_result.result.lineWins;

    var symbols = get_all_bigwin_symbols(lineWins);

    open_black_screen();

    anims_winlines_bigwin_play(symbols, lineWins, totalWin);
}

function get_all_bigwin_symbols(lineWins) {
    var allSymbolsObj = {};
    var allSymbolsArr = [];

    for(var i in lineWins) {
        var symbols = get_symbols_from_winset(lineWins[i]);

        for(var j = 0; j < symbols.length; j++) {
            var spriteName = symbols[j]['spriteName'];

            if(typeof allSymbolsObj[spriteName] !== "undefined") {
                continue;
            }

            allSymbolsObj[spriteName] = symbols[j];
        }
    }

    for(var i in allSymbolsObj) {
        allSymbolsArr.push(allSymbolsObj[i]);
    }

    return allSymbolsArr;
}

/**
 * @returns {Array<Object>}
 */
export function get_symbols_from_winset(win_set) {
    var symbols = [];

    for(var pos in win_set.position) {
        var xPos = win_set.position[pos][0];
        var yPos = win_set.position[pos][1];
        var yPosS = 2 - yPos;

        //var symbolIndex = server_result.result.reelMatrix[0][xPos][yPos];
        var symbObj = {
            'spriteName': "reels_bufer_" + xPos + "_S" + yPosS,
            'x': xPos,
            'y': yPosS,
            //isJoker: (get_symbol_name(symbolIndex) == "symbol_Joker")
        };

        symbols.push(symbObj);
    }

    return symbols;
}

function audio_play_win_line(winset) {
    if(typeof picture_convert[winset['symbol']] != 'undefined') {
        var symbol = picture_convert[winset['symbol']];
        madnes_audio_play("WIN_LINE_" + symbol);
    }
}

function get_symbol_on_position(x, y) {
    var sNum = server_result.result.reelMatrix[0][x][y];
    return picture_convert[sNum];
}

function get_symbol_name(i) {
    return picture_convert[i];
}

function get_orig_sprite_name(symbolName) {
    return madnes_get_texture(symbolName).replace("_blur", "");
}

export var wild_lock = -1; // -1 => no lock
export function set_wild_lock(lock) {
    wild_lock = lock;
}

export function set_wild_lock_index() {

    var betIdx = get_memory_index(bet);
    wild_lock = get_result_special_state()?.['wildMemory']?.[betIdx]?.['index'];

    /*if(server_result.result.lineWins) {
        wild_lock = -1;
    }*/
}